"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var colors_design_token_1 = __importDefault(require("@tdcerhverv/parrotfish/dist/colors-design-token"));
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var color_tools_1 = require("../../utils/color-tools");
var createPalette_1 = __importDefault(require("@material-ui/core/styles/createPalette"));
var black = colors_design_token_1.default.black, white = colors_design_token_1.default.white;
exports.palette = (0, createPalette_1.default)({
    common: {
        black: black,
        white: white,
    },
    primary: {
        contrastText: white,
        main: colors_design_token_1.default.primary,
        light: colors_design_token_1.default.primaryLight,
        dark: colors_design_token_1.default.primaryDark,
    },
    secondary: {
        contrastText: white,
        main: colors_design_token_1.default.secondary,
        light: (0, colorManipulator_1.lighten)(colors_design_token_1.default.secondary, 0.2),
        dark: colors_design_token_1.default.secondaryDark,
    },
    error: {
        contrastText: colors_design_token_1.default.errorLight,
        main: colors_design_token_1.default.error,
        light: colors_design_token_1.default.errorMediumLight,
        dark: colors_design_token_1.default.errorDark,
    },
    warning: {
        contrastText: colors_design_token_1.default.warningLight,
        main: colors_design_token_1.default.warning,
        light: colors_design_token_1.default.warningMediumLight,
        dark: colors_design_token_1.default.warningDark,
    },
    info: {
        contrastText: colors_design_token_1.default.infoLight,
        main: colors_design_token_1.default.info,
        light: colors_design_token_1.default.infoMediumLight,
        dark: colors_design_token_1.default.infoDark,
    },
    success: {
        contrastText: colors_design_token_1.default.successLight,
        main: colors_design_token_1.default.success,
        light: colors_design_token_1.default.successMediumLight,
        dark: colors_design_token_1.default.successDark,
    },
    grey: {
        50: (0, color_tools_1.mix)(white, colors_design_token_1.default.greyLightest),
        100: colors_design_token_1.default.greyLightest,
        200: colors_design_token_1.default.greyLight,
        300: colors_design_token_1.default.greyMediumLight,
        400: colors_design_token_1.default.greyMedium,
        500: colors_design_token_1.default.greyMediumDark,
        600: colors_design_token_1.default.greyDark,
        700: (0, color_tools_1.mix)(colors_design_token_1.default.greyDark, colors_design_token_1.default.greyDarkest),
        800: colors_design_token_1.default.greyDarkest,
        900: (0, color_tools_1.mix)(black, colors_design_token_1.default.greyDarkest),
    },
    text: {
        primary: black,
        secondary: colors_design_token_1.default.greyDark,
        disabled: colors_design_token_1.default.greyMediumLight,
        hint: colors_design_token_1.default.greyMediumLight,
    },
    divider: colors_design_token_1.default.greyMediumLight,
    background: {
        default: white,
        paper: white,
    },
    orange: colors_design_token_1.default.brandOrange,
    accent: colors_design_token_1.default.accent,
    accentDark: colors_design_token_1.default.accentDark,
});
